import {svgIconWrapper} from '../svg-icon-wrapper';

import HouseUserRegular from './house-user-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HouseUserRegular {...validProps} />;
}

SvgComponent.iconName = 'houseUserRegular';

export const HouseUserRegularIcon = svgIconWrapper(SvgComponent);
